import React from 'react';
import { getDisplayCompanyName } from '../utils/branding';

/**
 * Reusable Footer Component for authentication pages
 */
const AuthFooter = ({ domainConfig, showSignUp = false, showSignIn = false, onNavigate }) => {
  const displayCompanyName = getDisplayCompanyName(
    domainConfig?.companyName
  );

  return (
    <div className="login-footer">
      {(showSignUp || showSignIn) && (
        <p className="help-text">
          {showSignUp && (
            <>
              Don't have an account?{" "}
              <button
                type="button"
                className="link-button"
                onClick={() => onNavigate && onNavigate('/register')}
              >
                Sign Up
              </button>
            </>
          )}
          {showSignIn && (
            <>
              Already have an account?{" "}
              <button
                type="button"
                className="link-button"
                onClick={() => onNavigate && onNavigate('/login')}
              >
                Sign In
              </button>
            </>
          )}
        </p>
      )}
      <div className="footer-links" style={{ marginTop: "12px" }}>
        {domainConfig?.termUrl && (
          <a
            href={domainConfig.termUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Terms
          </a>
        )}
        {domainConfig?.termUrl && domainConfig?.policyUrl && (
          <span className="footer-separator"> & </span>
        )}
        {domainConfig?.policyUrl && (
          <a
            href={domainConfig.policyUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Policy
          </a>
        )}
      </div>
      <p className="help-text" style={{ marginTop: "8px" }}>
        Protected by {displayCompanyName} SSO | All rights reserved
      </p>
    </div>
  );
};

export default AuthFooter;
